// jQuery(document).ready(function ($) {

//   let isLoading = false;

//   function loadMoreProducts($wrapper) {
//     if (isLoading) return;

//     const nextPageUrl = $wrapper.data('next-page');
//     if (!nextPageUrl) return;

//     isLoading = true;

//     $.get(nextPageUrl, function (data) {
//       const $data = $(data);

//       /* IMPORTANT: correct selector */
//       const newProducts = $data.find('#product-grid > li');
//       const newWrapper = $data.find('.load-more-wrapper');

//       $('#product-grid').append(newProducts);

//       if (newWrapper.length) {
//         $wrapper.replaceWith(newWrapper);
//       } else {
//         $wrapper.remove(); // all products loaded
//       }

//       isLoading = false;
//     });
//   }

//   function isNearBottom(element) {
//     const rect = element.getBoundingClientRect();
//     return rect.top <= window.innerHeight + 200;
//   }

//   $(window).on('scroll', function () {
//     const $wrapper = $('.load-more-wrapper').last();
//     if (!$wrapper.length || isLoading) return;

//     if (isNearBottom($wrapper[0])) {
//       loadMoreProducts($wrapper);
//     }
//   });

// });
jQuery(document).ready(function ($) {

  let isLoading = false;
  let scrollTimeout = null;

  function loadMoreProducts($wrapper) {
    if (isLoading) return;

    const nextPageUrl = $wrapper.data('next-page');
    if (!nextPageUrl) return;

    isLoading = true;
    $wrapper.addClass('loading');

    $.get(nextPageUrl, function (data) {
      const $data = $(data);

      const newProducts = $data.find('#product-grid > li');
      const newWrapper  = $data.find('.load-more-wrapper');

      $('#product-grid').append(newProducts);

      if (newWrapper.length) {
        $wrapper.replaceWith(newWrapper);
      } else {
        $wrapper.remove();
      }

      isLoading = false;
    });
  }

  function isNearBottom(element) {
    const rect = element.getBoundingClientRect();
    return rect.top <= window.innerHeight + 600; // preload earlier
  }

  $(window).on('scroll', function () {
    if (scrollTimeout) return;

    scrollTimeout = setTimeout(function () {
      scrollTimeout = null;

      const $wrapper = $('.load-more-wrapper').last();
      if (!$wrapper.length || isLoading) return;

      if (isNearBottom($wrapper[0])) {
        loadMoreProducts($wrapper);
      }
    }, 100); // throttle scroll
  });

});
